"use client";

import { m } from "framer-motion";
import Magnetic from "@/components/motion/Magnetic";
import EditableText from "@/components/edit-mode/EditableText";

interface BrandSectionItemProps {
  section: { title: string; description: string };
  index: number;
}

export default function BrandSectionItem({ section, index }: BrandSectionItemProps) {
  return (
    <m.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{
        duration: 0.8,
        delay: 0.3 + index * 0.2,
        ease: [0.16, 1, 0.3, 1],
      }}
      className="group relative"
    >
      <m.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.5 + index * 0.2, duration: 0.6 }}
        className="text-background/5 group-hover:text-background/10 absolute top-0 -left-8 text-6xl font-black transition-colors duration-500"
      >
        0{index + 1}
      </m.span>

      <div className="border-background/20 group-hover:border-background/40 border-l-2 pl-6 transition-colors duration-500">
        <Magnetic>
          <m.h3
            className="text-muted-foreground mb-4 flex inline-block cursor-default items-center gap-2 text-[10px] font-black tracking-[0.25em] uppercase"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 + index * 0.2, duration: 0.6 }}
          >
            <span className="bg-foreground h-1 w-1 rounded-full"></span>
            <EditableText
              section="brandStatement"
              field={`sections.${index}.title`}
              value={section.title}
            />
          </m.h3>
        </Magnetic>
        <p className="text-muted-background text-lg leading-relaxed font-medium">
          <EditableText
            section="brandStatement"
            field={`sections.${index}.description`}
            value={section.description}
          />
        </p>
      </div>
    </m.div>
  );
}
